// components/CorrectionReceptionModal.jsx (version mise à jour)
import React, { useState, useEffect } from 'react';
import { Modal, Button, Space, Spin, Alert, Tag, Typography } from 'antd';
import { getCorrectionReceptionPreview, postCorrectionReception } from '../../../services/receptionService';

const { Text } = Typography;

const CorrectionReceptionModal = ({
    visible,
    variant,
    userId,
    onCancel,
    onSuccess
}) => {
    const [loading, setLoading] = useState(false);
    const [preview, setPreview] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    // Charger les données de prévisualisation
    useEffect(() => {
        if (visible && variant) {
            fetchPreview();
        }
    }, [visible, variant]);

    const fetchPreview = async () => {
        setLoading(true);
        try {
            const response = await getCorrectionReceptionPreview(variant.id_varianteProduit);
            if (response.data.success) {
                setPreview(response.data.data);
            }
        } catch (error) {
            console.error('❌ Erreur preview:', error);
        } finally {
            setLoading(false);
        }
    };

    console.log(userId)

    const handleConfirm = async () => {
        setSubmitting(true);
        try {
            const response = await postCorrectionReception(variant.id_varianteProduit, userId);
            if (response.data.success) {
                onSuccess && onSuccess(response.data.data);
                onCancel();
            }
        } catch (error) {
            console.error('❌ Erreur correction:', error);
        } finally {
            setSubmitting(false);
        }
    };

    // Afficher le loading
    if (loading) {
        return (
            <Modal
                title="Chargement..."
                open={visible}
                onCancel={onCancel}
                footer={null}
                width={500}
                centered
            >
                <div style={{ textAlign: 'center', padding: 40 }}>
                    <Spin size="large" />
                    <p style={{ marginTop: 16 }}>Calcul de la migration en cours...</p>
                </div>
            </Modal>
        );
    }

    // Si pas de preview
    if (!preview) {
        return null;
    }

    const { quantite_initiale_proposee, eligible_auto, warnings, stock_actuel } = preview;

    return (
        <Modal
            title="Confirmation de migration initiale"
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Annuler
                </Button>,
                <Button
                    key="confirm"
                    type="primary"
                    danger
                    onClick={handleConfirm}
                    loading={submitting}
                    disabled={!eligible_auto}
                >
                    Confirmer la migration
                </Button>
            ]}
            width={550}
            centered
        >
            <div>
                <Text type="secondary" style={{ fontSize: 14, marginBottom: 16, display: 'block' }}>
                    Migration initiale pour <strong>{variant?.nom_produit}</strong>
                </Text>

                {/* Infos produit */}
                <div style={{
                    background: '#fafafa',
                    padding: 16,
                    borderRadius: 8,
                    marginBottom: 16,
                    border: '1px solid #f0f0f0'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                        <span style={{ color: '#999' }}>Stock actuel</span>
                        <strong style={{ color: '#1677ff' }}>{stock_actuel || 0} unités</strong>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                        <span style={{ color: '#999' }}>Entrées totales</span>
                        <span>{preview.total_entrees || 0}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ color: '#999' }}>Sorties totales</span>
                        <span>{preview.total_sorties || 0}</span>
                    </div>
                </div>

                {/* Quantité proposée */}
                <div style={{
                    background: '#e6f7ff',
                    padding: 12,
                    borderRadius: 8,
                    border: '1px solid #91d5ff',
                    marginBottom: 12
                }}>
                    <Space>
                        <span style={{ color: '#1890ff', fontSize: 16 }}>📦</span>
                        <span style={{ color: '#0050b3', fontSize: 13 }}>
                            Quantité à migrer : <strong>{quantite_initiale_proposee}</strong> unités
                        </span>
                    </Space>
                </div>

                {/* Alertes */}
                {warnings && warnings.length > 0 && (
                    <Alert
                        message="Attention"
                        description={warnings.map((w, i) => <div key={i}>• {w}</div>)}
                        type="warning"
                        showIcon
                        style={{ marginBottom: 12 }}
                    />
                )}

                {/* Statut éligibilité */}
                {eligible_auto ? (
                    <Alert
                        message="Éligible à la migration automatique"
                        description="Cette variante peut être migrée automatiquement."
                        type="success"
                        showIcon
                    />
                ) : (
                    <Alert
                        message="Migration manuelle requise"
                        description="Cette variante contient des cas complexes (retour, échange, ajustement) qui nécessitent une validation humaine."
                        type="error"
                        showIcon
                    />
                )}
            </div>
        </Modal>
    );
};

export default CorrectionReceptionModal;